<template>
  <!-- prettier-ignore -->
  <div>
    <search-condition searchable :loading="searching" @do-search="search">
      <ns-company v-model="condition.companyId" />
      <n-field-id v-model="condition.accountId" label="accountId" />
      <n-field-datetime v-model="condition.from" label="from" />
      <n-field-datetime v-model="condition.to" label="to" />
    </search-condition>
    <n-table :total="total" :page-no="pageNo" :page-size="pageSize" :searched="searched" :searching="searching" :has-result="hasResult" @on-page-no="onPageNo" @on-page-size="onPageSize">
      <customer-transaction-table :records="records"></customer-transaction-table>
    </n-table>
  </div>
</template>

<script>
import CustomerView from './view';
import PaginateMixin from '@/mixins/paginate-mixin';
import CustomerTransactionTable from './CustomerCustomerTransactionTable';
import { history } from '@/api/customer/customer-customer-transaction';
import { Parser, setCurrencyScale } from '@/helpers/operators';
import {CURRENCY_SCALE_NAME} from "@/constant/enums";

export default CustomerView.extend({
  name: 'CustomerCustomerTransactionHistory',
  components: { CustomerTransactionTable },
  mixins: [PaginateMixin],
  props: {
    condition: Object,
  },
  watch: {
    searched() {
      this.$emit('searchedHasError', this.searched && this.hasSearchError);
    },
  },
  methods: {
    doSearch(params) {
      let aid = this.condition.accountId;
      if (aid === null || aid === undefined || aid === '') {
        return Promise.resolve({ key: 'error.account_required', level: 'ERROR', type: 'MESSAGE' });
      } else {
        let p = { ...params, ...this.condition };
        return history(p);
      }
    },
    parse(data) {
      this.records = Parser( data.records, [setCurrencyScale(CURRENCY_SCALE_NAME.CURRENCY)]);
      this.$emit('records', this.records);
    },
  },
});
</script>
